import { useModal } from '../modal-provider/ModalProvider';
export default useModal;
